import { render } from "./Add.vue?vue&type=template&id=1852a16e"
import script from "./Add.vue?vue&type=script&lang=js"
export * from "./Add.vue?vue&type=script&lang=js"

import exportComponent from "/srv/data/www/bylex_platform/cwt2/alpha/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/pages/TasksPriorities/Add.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1852a16e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1852a16e', __exports__)) {
    api.reload('1852a16e', __exports__)
  }
  
  module.hot.accept("./Add.vue?vue&type=template&id=1852a16e", () => {
    api.rerender('1852a16e', render)
  })

}


export default __exports__